const E = {
  JA_YEAR_MONTH: "yyyy年MM月",
  JA_MONTH_DAY: "MM月dd日",
  JA_YEAR_MONTH_DAY: "yyyy年MM月dd日",
  SLASH_YEAR_MONTH: "yyyy/MM",
  SLASH_DATE_FORMAT: "yyyy/MM/dd",
  HYPHEN_DATE_FORMAT: "yyyy-MM-dd",
  WEEKDAY_SLASH_DATE_FORMAT: "yyyy/MM/dd (eee)",
  WEEKDAY_SLASH_DATE_FORMAT_WIJMO: "yyyy/MM/dd (ddd)",
  WEEKDAY_HYPHEN_DATE_FORMAT: "yyyy-MM-dd (eee)",
  SLASH_DATE_TIME_FORMAT: "yyyy/MM/dd HH:mm",
  SLASH_DATE_TIME_FORMAT_NO_YEAR: "MM/dd HH:mm",
  HYPHEN_DATE_TIME_FORMAT: "yyyy-MM-dd HH:mm",
  DATE_TIME_SECOND_FORMAT: "yyyyMMddHHmmss",
  WEEKDAY_SLASH_DATE_TIME_FORMAT: "yyyy/MM/dd (eee) HH:mm",
  WEEKDAY_HYPHEN_DATE_TIME_FORMAT: "yyyy-MM-dd (eee) HH:mm",
  WEEKDAY_SLASH_DATE_TIME_SECOND_FORMAT: "yyyy/MM/dd (eee) HH:mm:ss",
  WEEKDAY_HYPHEN_DATE_TIME_SECOND_FORMAT: "yyyy-MM-dd (eee) HH:mm:ss",
  TIME_FORMAT: "HH:mm",
  TIME_SECOND_FORMAT: "HH:mm:ss",
  UTC_TIME_FORMAT: "HH:mm Z",
  UTC_TIME_SECOND_FORMAT: "HH:mm:ss Z",
  SLASH_DATE_TIME_SECOND_FORMAT: "yyyy/MM/dd HH:mm:ss",
  SLASH_DATE_FORMAT_NO_YEAR: "MM/dd",
  DATE_TIME_TZ_FORMAT: "yyyy-MM-dd HH:mm:ssXXX"
}, M = {
  TOKYO: "Asia/Tokyo",
  NEW_YORK: "America/New_York"
}, A = {
  BASE: 0,
  FORM_LAYOUT: 10,
  TOP_FIXED_AREA: 15,
  CONTENT: 300,
  HEADER: 1200,
  POPUP_WINDOW: 1300,
  ERROR_MESSAGE: 1600,
  ERROR_SCREEN: 2e3
}, T = (_) => `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv' style='fill: ${encodeURIComponent(
  _
)}; width: 24px; float: right;' focusable='false' aria-hidden='true' viewBox='0 0 24 24' data-testid='CalendarIcon'%3E%3Cpath d='M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z'%3E%3C/path%3E%3C/svg%3E")`, y = 15728640, H = 10485760, O = {
  minSize: { width: 300, height: 300 },
  maxSize: { width: 4096, height: 4096 }
}, R = "さらに表示する", d = "データがありません", D = "必須項目です。", S = {
  ALL: { TYPE_NUMBER: 0, NAME: "すべての協力会社" },
  ONLYFIRST: { TYPE_NUMBER: 1, NAME: "一次協力会社のみ" }
};
export {
  T as DATE_PICKER_ICON,
  E as DATE_TIME_FORMAT,
  D as ERROR_IS_REQUIRED,
  R as LOAD_MORE_DATA,
  y as MAX_FILE_SIZE_15MB,
  d as NO_DATA_OPTION,
  O as RAPIDA_FACE_IMAGE_RANGE_RESOLUTION,
  H as RAPIDA_FILE_MAX_SIZE,
  S as TARGET_PARTNER_COMPANY_TYPE,
  M as TIME_ZONES,
  A as ZINDEX
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@bld/bld-libs/constants.js
// module id = 211
// module chunks = 0